export default __webpack_public_path__ + "static/media/image 9.84d42b9912700ab8da143e7c86b5a081.svg";